import { render, staticRenderFns } from "./setMenuExamine.vue?vue&type=template&id=37a3fbe0&scoped=true"
import script from "./setMenuExamine.vue?vue&type=script&lang=js"
export * from "./setMenuExamine.vue?vue&type=script&lang=js"
import style0 from "./setMenuExamine.vue?vue&type=style&index=0&id=37a3fbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3fbe0",
  null
  
)

export default component.exports